import { render, staticRenderFns } from "./VehicleComponent.vue?vue&type=template&id=87527832&scoped=true"
import script from "./VehicleComponent.vue?vue&type=script&lang=js"
export * from "./VehicleComponent.vue?vue&type=script&lang=js"
import style0 from "./VehicleComponent.vue?vue&type=style&index=0&id=87527832&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87527832",
  null
  
)

export default component.exports